/**
 * A no-op logger
 */
export class NoopLogger {
    // ASSERTTAG_IGNORE_START
    sendTraceTag() { }
    shipAssertTag() { }
    debugAssertTag() { }
    setCorrelationId() { }
}
//# sourceMappingURL=NoopLogger.js.map